import { render, staticRenderFns } from "./mcrButton.vue?vue&type=template&id=69d50d37&scoped=true"
import script from "./mcrButton.vue?vue&type=script&lang=js"
export * from "./mcrButton.vue?vue&type=script&lang=js"
import style0 from "./mcrButton.vue?vue&type=style&index=0&id=69d50d37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d50d37",
  null
  
)

export default component.exports